export class PaymentPageOperationEndedError extends Error {}

// Owns the lifetime of asynchronous work for one page or polling run.
export function createPaymentPageScope(context) {
    let active = true;
    const isActive = () => active && (!context.isActive || context.isActive());
    const guarded = (operation) => (...args) => {
        if (isActive()) return operation(...args);
    };
    return {
        ...context,
        isActive,
        updateView: guarded(context.updateView),
        updateOrderSummary: guarded(context.updateOrderSummary),
        dispose: () => { active = false; },
    };
}

export function assertPageActive(context) {
    if (!context.isActive()) throw new PaymentPageOperationEndedError("This payment page operation has ended.");
}
